import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { AssistanceProgramCreationContent } from './components/AssistanceProgramCreationContent';

export default function AssistanceProgramCreation() {
    return (
        <MainContent
            component={<AssistanceProgramCreationContent />}
            titulo='Programa asistencia al paciente'
            noBackground
        />
    );

};
